/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import { useSearchParams } from 'react-router';

import { NewsletterPromo } from 'site-kit';

import { NewsletterModal } from './NewsletterModal';

export function NewsletterPromoAndModal() {
    const [searchParams] = useSearchParams();

    // Initially true because the modal rendering is gated by the "newsletterSubscription" URL parameter
    const [isModalOpen, setIsModalOpen] = React.useState(true);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    // After a successful subscription, ActiveCampaign redirects the user back to the
    // homepage with a "newsletterSubscription=success" URL parameter so that we know the
    // user has just subscribed to the newsletter. In this case, we show a success modal
    // and don't show the previously-visible Newsletter signup form
    const hasSuccessParam = searchParams.get('newsletterSubscription') === 'success';

    if (hasSuccessParam) {
        return <NewsletterModal isModalOpen={isModalOpen} closeModal={closeModal} />;
    }

    return <NewsletterPromo />;
}
